import { ReactNode } from 'react';

export function EyebrowLabel({
  children,
  muted,
  spacing = 'sm',
  className = '',
}: {
  children: ReactNode;
  muted?: boolean;
  spacing?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <span
      className={`text-uppercase fw-bold d-block ${spacing === 'md' ? 'mb-2' : 'mb-1'} ${muted ? 'mutedText' : ''} ${className}`}
      style={{ fontSize: 11, letterSpacing: '0.05em' }}
    >
      {children}
    </span>
  );
}
